<script src="../../lists.module.ts"></script>
<kt-portlet class="edit-doctor-div">
  <kt-portlet-header
    [title]="getTitle() | translate"
    [viewLoading$]="loading$"
    class="cards-inside-doctor-form card-head-lg card-head"
  >
    <ng-container ktPortletTools class="cards-inside-doctor-form">
      <a
        (click)="goBack()"
        class="btn btn-secondary mr-2"
        mat-raised-button
        matTooltip="{{ 'AUTH.INPUT.BACK' | translate }}"
      >
        <i class="la la-arrow-left"></i>
        <span class="hidden-mobile"> {{ 'AUTH.INPUT.BACK' | translate }}</span>
      </a>
      <a
        href="javascript:;"
        class="btn btn-secondary mr-2"
        (click)="reset()"
        [disabled]="selectedTab !== 0"
        mat-raised-button
        matTooltip="{{ 'AUTH.RESET.BUTTON' | translate }}"
      >
        <i class="la la-cog"></i>
        <span class="hidden-mobile">{{ 'AUTH.RESET.BUTTON' | translate }}</span>
      </a>
      <a
        href="javascript:;"
        class="btn btn-primary mr-2"
        color="primary"
        (click)="onSumbit()"
        mat-raised-button
        matTooltip="Save & Continue"
      >
        <span class="hidden-mobile"> {{ 'AUTH.INPUT.SAVE' | translate }}</span>
      </a>
    </ng-container>
  </kt-portlet-header>

  <div *ngIf="practitionRole">
    <form [formGroup]="practitionRoleForm" class="form form-group-seperator-dashed">
      <kt-alert
        *ngIf="hasFormErrors"
        type="warn"
        [showCloseButton]="true"
        [duration]="10000"
        (closeAl)="onAlertClose()"
      >
        {{ 'AUTH.VALIDATION.INVALID_OR_REQUIRED' | translate }}
      </kt-alert>
      <kt-alert
        *ngIf="hasSubmissionErrors && !hasFormErrors"
        type="warn"
        [duration]="30000"
        [showCloseButton]="true"
        (closeAl)="onAlertClose()"
      >
        <ul>
          <li *ngFor="let msg of submissionErrorObj">{{ msg.error | translate }}</li>
        </ul>
      </kt-alert>
      <div class="form-section form-section-first whole-form">
        <div class="form-group row cards-inside-doctor-form">
          <div class="col-lg-12 card-header-doctor-form">
            <h4>{{ 'PR.INPUT.DEMOGRAPHICS' | translate }}</h4>
          </div>
          <div class="col-lg-6 kt-margin-bottom-20-mobile">
            <mat-form-field appearance="fill" class="mat-form-field-fluid">
              <mat-label translate="PR.INPUT.CODE">Event</mat-label>
              <input
                matInput
                [matAutocomplete]="auto"
                (ngModelChange)="codeInputChanged($event)"
                #codeInput
                formControlName="code"
                multiple
              />
              <mat-icon matSuffix>arrow_drop_down</mat-icon>
              <mat-autocomplete
                autoActiveFirstOption
                #auto="matAutocomplete"
                (optionSelected)="selectedCode($event)"
              >
                <!--  [displayWith]="displayFnCode" -->
                <mat-option *ngFor="let code of filteredCode | async" [value]="code">
                  {{ code.concept.fsn.term }}
                </mat-option>
              </mat-autocomplete>
              <mat-error *ngIf="isControlHasError('code', 'required')">
                {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-lg-6 kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid" appearance="fill">
              <mat-label>{{ 'PR.INPUT.SPECIALTY' | translate }}</mat-label>
              <input
                matInput
                [matAutocomplete]="autospecialty"
                (ngModelChange)="specialtyInputChanged($event)"
                #specialtyInput
                formControlName="specialty"
              />
              <mat-icon matSuffix>arrow_drop_down</mat-icon>
              <mat-autocomplete
                autoActiveFirstOption
                #autospecialty="matAutocomplete"
                (optionSelected)="selectedspecialty($event)"
              >
                <!--  [displayWith]="displayFnspecialty" -->
                <mat-option *ngFor="let specialty of filteredspecialty | async" [value]="specialty">
                  {{ specialty.concept.fsn.term }}
                </mat-option>
              </mat-autocomplete>
              <mat-error *ngIf="isControlHasError('specialty', 'required')">
                {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-lg-5 kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid" appearance="fill">
              <mat-label>{{ 'PR.INPUT.PERIOD_START' | translate }}</mat-label>
              <input matInput [matDatepicker]="period_start" formControlName="period_start" />
              <mat-datepicker-toggle matSuffix [for]="period_start"></mat-datepicker-toggle>
              <mat-datepicker #period_start></mat-datepicker>
              <mat-error *ngIf="isControlHasError('period_start', 'required')">
                {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-lg-5 kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid" appearance="fill">
              <mat-label>{{ 'PR.INPUT.PERIOD_END' | translate }}</mat-label>
              <input matInput [matDatepicker]="period_end" formControlName="period_end" />
              <mat-datepicker-toggle matSuffix [for]="period_end"></mat-datepicker-toggle>
              <mat-datepicker #period_end></mat-datepicker>
              <mat-error *ngIf="isControlHasError('period_end', 'required')">
                {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-lg-2 kt-margin-bottom-20-mobile" style="padding-left: 30px">
            <mat-label class="row" translate="PR.INPUT.STATUS"> Status</mat-label>
            <mat-slide-toggle class="row mt-2 mr-2" formControlName="active"> </mat-slide-toggle>
            <mat-hint align="start">
              <strong>{{ getStatusString() }}</strong>
            </mat-hint>
          </div>
        </div>
        <div class="form-group row cards-inside-doctor-form">
          <div class="col-lg-12 card-header-doctor-form">
            <h4>{{ 'PR.INPUT.AVAILABILITY' | translate }}</h4>
          </div>

          <div class="col-lg-6 kt-margin-bottom-20-mobile">
            <div class="row">
              <div class="col-lg-12 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid" appearance="fill">
                  <mat-label>{{ 'PR.INPUT.DAYS' | translate }}</mat-label>
                  <mat-select
                    placeholder="Select days"
                    [(ngModel)]="dayIdForAdding"
                    formControlName="daysOfWeek"
                    multiple
                  >
                    <mat-option *ngFor="let day of unassignedDays" value="{{ day }}">{{
                      day
                    }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-5 kt-margin-bottom-20-mobile justify-content-center">
                <table>
                  <tr>
                    <td><strong>From:</strong>&nbsp;&nbsp;</td>
                    <td>
                      <ngb-timepicker
                        [spinners]="'false'"
                        [size]="'small'"
                        formControlName="availableStartTime"
                      ></ngb-timepicker>
                    </td>
                  </tr>
                </table>
              </div>
              <div class="col-lg-5 kt-margin-bottom-20-mobile justify-content-center">
                <table>
                  <tr>
                    <td><strong>To:</strong>&nbsp;&nbsp;</td>
                    <td>
                      <ngb-timepicker
                        [spinners]="'false'"
                        [size]="'small'"
                        formControlName="availableEndTime"
                      ></ngb-timepicker>
                    </td>
                  </tr>
                </table>
              </div>
              <div
                class="col-lg-2 kt-margin-bottom-20-mobile justify-content-center"
                style="padding-top: 5%"
              >
                <a
                  href="javascript:;"
                  class="btn btn-primary mr-2"
                  color="primary"
                  (click)="assignTime()"
                  mat-raised-button
                  matTooltip="assign time"
                >
                  <span class="hidden-mobile"> {{ 'AUTH.INPUT.ASSIGN_TIME' | translate }}</span>
                </a>
              </div>
            </div>
          </div>
          <div class="col-lg-6 kt-margin-bottom-20-mobile">
            <div class="list-timeline list-timeline-user-role" *ngIf="assignedTime.length > 0">
              <div class="list-timeline-items">
                <div class="list-timeline-item m-0 p-0" *ngFor="let time of assignedTime">
                  <span class="list-timeline-badge list-timeline-badge-primary"></span>
                  <span class="list-timeline-text"
                    >{{ time['daysOfWeek'] }} from {{ time['availableStartTime'] }} to
                    {{ time['availableEndTime'] }}</span
                  >
                  <span class="list-timeline-time">
                    <button
                      mat-icon-button
                      color="warn"
                      matTooltip="Remove time"
                      type="button"
                      (click)="unassingTime(time)"
                    >
                      <mat-icon>delete</mat-icon>
                    </button>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid" appearance="fill">
              <mat-label>{{ 'PR.INPUT.NOT_AVAILABLE_START' | translate }}</mat-label>
              <input
                matInput
                [matDatepicker]="notAvailable_start"
                formControlName="notAvailable_start"
              />
              <mat-datepicker-toggle matSuffix [for]="notAvailable_start"></mat-datepicker-toggle>
              <mat-datepicker #notAvailable_start></mat-datepicker>
            </mat-form-field>
          </div>

          <div class="col-lg-6 kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid" appearance="fill">
              <mat-label>{{ 'PR.INPUT.NOT_AVAILABLE_END' | translate }}</mat-label>
              <input
                matInput
                [matDatepicker]="notAvailable_end"
                formControlName="notAvailable_end"
              />
              <mat-datepicker-toggle matSuffix [for]="notAvailable_end"></mat-datepicker-toggle>
              <mat-datepicker #notAvailable_end></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="col-lg-6 kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid" appearance="fill">
              <mat-label>{{ 'PR.INPUT.NOT_AVAILABLE_DESC' | translate }}</mat-label>
              <textarea matInput formControlName="notAvailable_description" rows="4"></textarea>
              <mat-error *ngIf="isControlHasError('notAvailable_description', 'required')">
                {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-lg-6 kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid" appearance="fill">
              <mat-label>{{ 'PR.INPUT.AVAILABLE_EXCEPTIONS' | translate }}</mat-label>
              <textarea matInput formControlName="availabilityExceptions" rows="4"></textarea>
            </mat-form-field>
          </div>
        </div>
      </div>
    </form>
  </div>
</kt-portlet>
